export const parseOperationalTypeOptions = () => {
  var localProductOptions = localStorage.getItem("operationalTypes");
  var productTypeArray = [];
  if (localProductOptions !== undefined && localProductOptions !== null) {
    var i = 0;
    var productTypeList = localStorage.getItem("operationalTypes").split(",");
    productTypeList.forEach(e => {
      productTypeArray[i] = {
        label: e,
        value: e
      };
      i++;
    });
    return productTypeArray;
  } else {
    productTypeArray.push({ label: "SIMPLE", value: "SIMPLE" });
    productTypeArray.push({ label: "CONFIGURABLE", value: "CONFIGURABLE" });
    productTypeArray.push({ label: "VARIABLE", value: "VARIABLE" });
    return productTypeArray;
  }
};
export const parseFlowItemStatusOptions = () => {
  var localProductOptions = localStorage.getItem("flowItemStatusTypes");
  var productTypeArray = [];
  if (localProductOptions !== undefined && localProductOptions !== null) {
    var i = 0;
    var productTypeList = localStorage
      .getItem("flowItemStatusTypes")
      .split(",");
    productTypeList.forEach(e => {
      productTypeArray[i] = {
        label: e,
        value: e
      };
      i++;
    });
    return productTypeList;
  } else {
    productTypeArray.push("BACKLOG");
    productTypeArray.push("IN PROGRESS");
    productTypeArray.push("COMPLETE");
    productTypeArray.push("FAULT");
    return productTypeArray;
  }
};
export const parseStockOptions = () => {
  var localPartOptions = localStorage.getItem("stockTypes");
  var partTypeArray = [];
  if (localPartOptions !== undefined && localPartOptions !== null) {
    var i = 0;
    var partTypeList = localStorage.getItem("stockTypes").split(",");

    partTypeList.forEach(e => {
      partTypeArray[i] = {
        label: e,
        value: e
      };
      i++;
    });
    return partTypeArray;
  } else {
    partTypeArray.push({ label: "MANUFACTURED", value: "MANUFACTURED" });
    partTypeArray.push({ label: "PURCHASED", value: "PURCHASED" });

    return partTypeArray;
  }
};

export const parseProductTypeOptions = () => {
  var localProductOptions = localStorage.getItem("productTypes");
  var productStockTypeArray = [];
  if (localProductOptions !== undefined && localProductOptions !== null) {
    var i = 0;
    var productTypeList = localStorage.getItem("productTypes").split(",");

    productTypeList.forEach(e => {
      productStockTypeArray[i] = {
        label: e,
        value: e
      };
      i++;
    });
    return productStockTypeArray;
  } else {
    productStockTypeArray.push({ label: "PRODUCT", value: "PRODUCT" });
    productStockTypeArray.push({
      label: "SUB-ASSEMBLY",
      value: "SUB-ASSEMBLY"
    });
    return productStockTypeArray;
  }
};

export const parseAttributeTypeOptions = () => {
  var localAttributeOptions = localStorage.getItem("attributeTypes");
  var attributeTypeArray = [];
  if (localAttributeOptions !== undefined && localAttributeOptions !== null) {
    var i = 0;
    var attributeTypeList = localStorage.getItem("attributeTypes").split(",");

    attributeTypeList.forEach(e => {
      attributeTypeArray[i] = {
        label: e,
        value: e
      };
      i++;
    });
    return attributeTypeArray;
  } else {
    attributeTypeArray.push({ label: "LIST", value: "LIST" });
    attributeTypeArray.push({ label: "INPUT", value: "INPUT" });
    return attributeTypeArray;
  }
};
export const parseStationStatusOptions = () => {
  var statusArray = [];
  if (
    localStorage.getItem("stationOperationalStatus") !== undefined &&
    localStorage.getItem("stationOperationalStatus") !== null
  ) {
    var i = 0;
    var statusList = localStorage
      .getItem("stationOperationalStatus")
      .split(",");
    statusList.forEach(e => {
      statusArray[i] = {
        label: e,
        value: e
      };
      i++;
    });
    return statusArray;
  } else {
    statusArray.push({ label: "ACTIVE", value: "ACTIVE" });
    statusArray.push({ label: "INACTIVE", value: "INACTIVE" });
    statusArray.push({ label: "FAULT", value: "FAULT" });
    statusArray.push({ label: "INVALID", value: "INVALID" });
    return statusArray;
  }
};

export const productCollapseObject = () => {
  var collapsable = {};
  collapsable.detail = false;
  collapsable.image = true;
  collapsable.attribute = true;
  collapsable.part = true;
  collapsable.sub = true;
  collapsable.flow = true;

  return collapsable;
};



// WEBPACK FOOTER //
// ./src/common/config/Storage.js